import { addMonths, addYears, endOfDay, isAfter, isBefore, isEqual, max, min } from 'date-fns';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils';
import Menu from './DateRangePickerComponents/DateRangePickerComponentMenu';
import { MARKERS } from './types';
import { getDefaultRanges, getValidatedMonths, parseOptionalDate } from './utils';
const DateRangePicker = (props) => {
    const { dateFormat = 'dd/MM/yyyy', definedRanges, disableSelectMonthDropdown, initialDateRange, locale, maxDate, maxRangeInMonths, minDate, testId = 'DateRangePicker', onChange, open, weekStartsOn = 1, } = props;
    const defaultRanges = getDefaultRanges(new Date());
    const today = new Date();
    const minDateValid = parseOptionalDate(minDate, addYears(today, -2));
    const maxDateValid = parseOptionalDate(maxDate, addYears(today, 1));
    const [intialFirstMonth, initialSecondMonth] = getValidatedMonths(initialDateRange || {}, minDateValid, maxDateValid);
    const [dateRange, setDateRange] = React.useState({ ...initialDateRange });
    const [firstMonth, setFirstMonth] = React.useState(intialFirstMonth || today);
    const [secondMonth, setSecondMonth] = React.useState(initialSecondMonth || today);
    const setFirstMonthValidated = (date) => {
        if (isEqual(date, secondMonth) || isBefore(date, secondMonth)) {
            setFirstMonth(date);
        }
    };
    const setSecondMonthValidated = (date) => {
        if (isEqual(date, firstMonth) || isAfter(date, firstMonth)) {
            setSecondMonth(date);
        }
    };
    const setDateRangeValidated = (range) => {
        let { startDate: newStart, endDate: newEnd } = range;
        if (newStart && newEnd) {
            range.startDate = newStart = max([newStart, minDateValid]);
            range.endDate = newEnd = min([newEnd, maxDateValid]);
            setDateRange(range);
            onChange(range);
            setFirstMonth(newStart);
            setSecondMonth(newEnd);
        }
    };
    const onDayClick = (marker, day) => {
        const { startDate } = dateRange;
        if (startDate && !isBefore(day, startDate) && marker === MARKERS.SECOND_MONTH) {
            const endDate = endOfDay(day);
            const newRange = { startDate, endDate };
            onChange(newRange);
            setDateRange(newRange);
        }
        if (marker === MARKERS.FIRST_MONTH) {
            setDateRange({ startDate: day, endDate: undefined });
        }
    };
    const onMonthNavigate = (marker, action) => {
        if (marker === MARKERS.FIRST_MONTH) {
            const firstNew = addMonths(firstMonth, action);
            setFirstMonth(firstNew);
        }
        else {
            const secondNew = addMonths(secondMonth, action);
            setSecondMonth(secondNew);
        }
    };
    const handlers = {
        onDayClick,
        onMonthNavigate,
    };
    return (open && (React.createElement(Menu, { "data-testid": `${testId}`, dateFormat: dateFormat, dateRange: dateRange, disableSelectMonthDropdown: disableSelectMonthDropdown, firstMonth: firstMonth, handlers: handlers, locale: locale, maxDate: maxDateValid, maxRangeInMonths: maxRangeInMonths, minDate: minDateValid, ranges: definedRanges || defaultRanges, secondMonth: secondMonth, setDateRange: setDateRangeValidated, setFirstMonth: setFirstMonthValidated, setSecondMonth: setSecondMonthValidated, weekStartsOn: weekStartsOn })));
};
const ComposedDateRangePicker = compose(withBaseProps())(DateRangePicker);
ComposedDateRangePicker.displayName = 'DateRangePicker';
export default ComposedDateRangePicker;
//# sourceMappingURL=DateRangePicker.js.map